import React from "react";
import { ArrowBackCircle } from "react-ionicons";
import constantURI from "../URI";
import _post from "../Functions/Post";
import SearchFilterFunction from "../Functions/SearchFilter";
import stylesASAP from "./stylesASAP";
import ASAPAuthenticate from "../Functions/ASAPAuthenticate";
import stylesMed from "../MedRep/stylesMed";
import _postBody from "../Functions/Post";
import { db, getDocs, collection, disableNetwork } from "../firebase";
import { set, get } from "idb-keyval";
import { FcPlus } from "react-icons/fc";
import { findIncompleteCashSalesForSync } from "../Functions/LoginFlow";

const getPartnerId = (item) => {
  if (!item || item === null) return null;

  const partnerId = item.partner_id;
  if (Array.isArray(partnerId)) return partnerId[0] ?? null;
  if (partnerId && typeof partnerId === "object") {
    return partnerId.id ?? partnerId[0] ?? null;
  }

  return null;
};

export default class TransactionListASAP extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      checked: [],
      orders: [],
      ordersCopy: [],
      isDelivered: true,
      authenticate: false,
      alertUndefined: false,
      isDraft: true,
      isDone: false,
      delivered: [],
      pending: [],
      USSO: [],
      token: "",
      selectedClient: 0,
      currentType: -1,
      amountToPay: 0,
      preventSymbols: ["e", "E", "+", "-"],
      isChecked: false,
      orderLine: [],
      pendingInvoices: [],
      order: [],
      signature: "",
      deviceWidth: window.innerWidth,
      isVendor: false,
      username: "",
      //Predefined ids for the transaction types
      transactionTypes: [
        {
          id: 0,
          name: "Orders",
          button: "Orders",
          SOs: "GetSOs?token=",
          SOLs: "GetSOLs?token=",
          FB: "Orders",
          FBL: "OrderLines",
        },
        {
          id: 1,
          name: "Returns",
          button: "Returns",
          SOs: "GetSOs?token=",
          SOLs: "GetSOLs?token=",
          FB: "Orders",
          FBL: "OrderLines",
        },
        {
          id: 2,
          name: "Purchase",
          button: "Purchase",
          SOs: "GetPOs?token=",
          SOLs: "GetPOLs?token=",
          FB: "Purchase",
          FBL: "PurchaseLines",
        },
        {
          id: 3,
          name: "Invoices",
          button: "Payment",
          SOs: "GetTransDue?token=",
          SOLs: "GetInvoiceLines?token=",
          FB: "Invoices",
        },
        {
          id: 4,
          name: "Delivery",
          button: "Delivery",
          SOs: "GetSOs?token=",
          SOLs: "GetSOLs?token=",
          FB: "Orders",
          FBL: "OrderLines",
        },
        {
          id: 5,
          name: "CashSales",
          button: "Cash Sales",
          SOs: "GetSOs?token=",
          SOLs: "GetSOLs?token=",
          FB: "Orders",
          FBL: "OrderLines",
        },
      ],
    };
  }

  async componentDidMount() {
    document.body.style.backgroundColor = "#e6e6fa";

    //Set transaction type
    await this.setState({
      currentType: this.props.type,
      username: JSON.parse(localStorage.getItem("Username")),
    });
    if (this.state.currentType === 2) {
      await this.setState({
        isVendor: true,
        ...(this.state.transactionTypes[4].SOs = "GetPOs?token="),
        ...(this.state.transactionTypes[4].SOLs = "GetPOLs?token="),
        ...(this.state.transactionTypes[4].FB = "Purchase"),
        ...(this.state.transactionTypes[4].FBL = "PurchaseLines"),
      });
    }
    if (this.props.delivery) {
      await this.setState({ currentType: 4 });
    }
    if (this.state.currentType === 3) {
      this.setState({ isDraft: false, isDelivered: true, isDone: false });
    }

    await this.getDataStoredLocaly();

    await this.getData();

    await this.getTransactionLines();

    //If current type is payment get the checked invoices
    const pendingInvoices = JSON.parse(localStorage.getItem("PendingInvoices"));
    if (
      this.state.currentType === 3 &&
      pendingInvoices !== null &&
      pendingInvoices.length !== 0
    ) {
      await this.setState({ pendingInvoices: pendingInvoices });
      await this.checkPendingOrders();
    }
  }

  readData = async () => {
    try {
      // Use 'get' method from idb-keyval to read data from IndexedDB
      const data = await get(
        this.state.transactionTypes[this.state.currentType].FB
      );

      if (data) {
        this.setState({ orders: data, ordersCopy: data });
        console.log(this.state.orders);
        console.log("orders from IndexedDB:", data);
      } else {
        console.log("orders not found in IndexedDB.");
      }
    } catch (error) {
      console.error("Error reading orders from IndexedDB:", error);
    }
  };

  readDataLine = async () => {
    if (this.state.currentType !== 3) {
      try {
        // Use 'get' method from idb-keyval to read data from IndexedDB
        const data = await get(
          this.state.transactionTypes[this.state.currentType].FBL
        );

        if (data) {
          this.setState({ orderLine: data });
          console.log(this.state.orderLine);
          console.log("orderLine from IndexedDB:", data);
        } else {
          console.log("orderLine not found in IndexedDB.");
        }
      } catch (error) {
        console.error("Error reading orderLine from IndexedDB:", error);
      }
    } else {
      var orderLine = localStorage.getItem("InvoicesLines");
      await this.setState({ orderLine: JSON.parse(orderLine) });
    }
  };

  getDataStoredLocaly = async () => {
    //Get and set needed data from local storage
    const token = localStorage.getItem("Token");
    const client = localStorage.getItem("SelectedClient");
    const SODetail = JSON.parse(localStorage.getItem("UnsyncedTransactions"));
    const currentTab = JSON.parse(localStorage.getItem("CurrentTab"));
    await this.setState({
      token: JSON.parse(token),
      selectedClient: JSON.parse(client),
    });
    // Load last synced transactions so Sent tab can show recently synced entries
    try {
      const last = JSON.parse(localStorage.getItem("LastSyncedTransactions")) || [];
      const lastForType = last[this.state.currentType] || [];
      await this.setState({ lastSynced: lastForType });
    } catch (e) {
      await this.setState({ lastSynced: [] });
    }
    //Set last selected Tab
    if (currentTab.length !== 0) {
      await this.setState({
        isDraft: currentTab[0].isDraft,
        isDelivered: currentTab[0].isDelivered,
        isDone: currentTab[0].isDone,
      });
      localStorage.setItem("CurrentTab", JSON.stringify([]));
    }
    //If there is no data in the local storage for the current type
    if (
      SODetail[this.state.currentType] === undefined ||
      SODetail[this.state.currentType] === null
    ) {
      this.setState({ disbaleSync: true });
    }
    //If there is data in the local storage for the current type
    else {
      if (SODetail[this.state.currentType] !== null) {
        this.FilterPendingItemsByName(SODetail[this.state.currentType]);
      }
    }
  };

  getTransactionLines = async () => {
    await this.readDataLine();
  };

  isChecked = async () => {
    var isChecked = false;
    await this.state.orders.map((order) => {
      if (order.checked !== undefined && order.checked === true) {
        isChecked = true;
      }
    });
    await this.setState({ isChecked: isChecked });
  };

  getData = async () => {
    await this.readData();
    this.getTransactions();
  };

  getTransactions = async () => {
    if (this.state.orders !== null) {
      await this.FilterItemsByName(this.state.orders);
    }
  };

  FilterItemsByName = async (items) => {
    var filteredItems = [];
    await items.map((item, index) => {
      const partnerId = getPartnerId(item);
      if (partnerId === this.state.selectedClient) filteredItems.push(item);
    });
    // Merge any recently synced items for the current type (avoid duplicates)
    try {
      const last = JSON.parse(localStorage.getItem("LastSyncedTransactions")) || [];
      const lastForType = last[this.state.currentType] || [];
      lastForType.forEach((l) => {
        // partner_id may be an array [id, name]
        const partnerId = Array.isArray(l.partner_id) ? l.partner_id[0] : (l.partner_id && l.partner_id[0]) || null;
        if (partnerId === this.state.selectedClient) {
          // avoid duplicate by id or name
          const exists = filteredItems.find((f) => (f.id && l.id && f.id === l.id) || (f.name && f.name === l.name));
          if (!exists) filteredItems.unshift(l);
        }
      });
    } catch (e) {
      // ignore
    }
    await this.setState({ orders: filteredItems, loading: false });
  };

  FilterPendingItemsByName = async (items) => {
    var filteredItems = [];
    await items.map((item, index) => {
      if (item !== null) {
        const partnerId = getPartnerId(item);
        if (partnerId === this.state.selectedClient) filteredItems.push(item);
      }
    });
    await this.setState({ pending: filteredItems });
  };

  checkPendingOrders = async () => {
    //Disable invoices that are unsynced
    await this.state.orders.map(async (order, index) => {
      await this.state.pendingInvoices.map((pendingInvoice) => {
        if (order.id === pendingInvoice.id) {
          this.setState({ ...(this.state.orders[index].disable = true) });
        }
      });
    });
  };

  onTabPress = (draft, delivered, done) => {
    this.setState({ isDelivered: delivered, isDraft: draft, isDone: done });
  };

  onSearch = async (text) => {
    var values = await SearchFilterFunction(
      text,
      this.state.pending,
      this.state.pending,
      this.state.noData
    );
    this.setState({ orders: values.items, noData: values.noData });
    this.FilterItemsByName(this.state.orders);
  };

  onSync = async () => {
    const incompleteCashSales = findIncompleteCashSalesForSync();
    if (this.state.currentType === 5 && incompleteCashSales.length > 0) {
      const names = incompleteCashSales.map((name, index) => `${index + 1}. ${name}`).join("\n");
      alert(
        "Cash invoice sync blocked: one or more cash invoices are missing payment data.\n\n" +
          names +
          "\n\nSuggested solutions:\n- Complete the payment for the affected invoice before syncing.\n- If the invoice is not needed, delete it and sync again."
      );
      await this.setState({ loading: false });
      return;
    }

    //Get unsynced transactions of current transaction type
    const UST = JSON.parse(localStorage.getItem("UnsyncedTransactions"));
    await this.setState({ USSO: UST[this.state.currentType] });
    //Check if there is internet connectivity
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    //If there is transactions to sync
    if (this.state.USSO.length !== 0) {
      this.setState({ loading: true });
      //Sync if connected to the internet
      if (this.state.authenticate) {
        this.state.USSO.map(async (SO, SOIndex, SOArr) => {
          if (this.state.currentType === 4 && SO.basedSO) {
            this.setState({ order: SO.order, signature: SO.signature });
            this.confirm();
          } else {
            //Create transaction
            _postBody(SO.createURL, SO.Body).then((response) => {
              return response.json().then(async (data) => {
                if (data.result !== undefined) {
                  //Set Signature
                  if (this.state.currentType === 3)
                    await this.setState({
                      ...(this.state.USSO[SOIndex].signatureUrl =
                        SO.signatureUrl.substring(
                          0,
                          SO.signatureUrl.indexOf("&id=") + 4
                        ) + data.result),
                    });
                  else
                    await this.setState({
                      ...(this.state.USSO[SOIndex].signatureUrl =
                        SO.signatureUrl.substring(
                          0,
                          SO.signatureUrl.indexOf("&id=") + 4
                        ) + data.result.results[0].recordID),
                    });
                } else {
                  this.setState({ alertUndefined: true });
                }
                //If transaction is payment create trans receipts
                if (this.state.currentType === 3) {
                  _post(SO.userUrl);
                  SO.Invoices.map((invoice) => {
                    const realURL =
                      invoice.URL.substring(
                        0,
                        invoice.URL.indexOf("&paymentId=") + 11
                      ) + data.result;
                    _post(realURL);
                    _post(invoice.UpdateURL);
                  });
                }
                var body = {};
                body.signature = SO.signature;
                _postBody(SO.signatureUrl, body).then((response) => {
                  return response.json().then(async (data) => {
                    //Empty local storage
                    await localStorage.setItem(
                      "UnsyncedTransactionsCount",
                      JSON.stringify([])
                    );
                    await localStorage.setItem(
                      "UnsyncedTransactions",
                      JSON.stringify([])
                    );
                    await localStorage.setItem(
                      "PendingInvoices",
                      JSON.stringify([])
                    );
                    await window.location.reload();
                    await alert("Synced Successfully");
                    await this.setState({ isDraft: true, isDelivered: false });
                  });
                });
              });
            });
          }
        });
      } else {
        alert("Only sync when connected to the Internet!");
        await this.setState({ loading: false });
      }
    }
  };

  confirm = async () => {
    var confirm =
      constantURI() +
      "Action?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&id=" +
      this.state.order.id +
      "&action=";
    if (this.state.isVendor) {
      confirm = confirm + "button_confirm" + "&table=" + "purchase.order";
    } else {
      confirm = confirm + "action_confirm" + "&table=" + "sale.order";
    }
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    if (this.state.authenticate) {
      await _post(confirm);
      await this.getDelivery();
    }
  };

  getDelivery = async () => {
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    const getDelivery =
      constantURI() +
      "GetDelivery?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&source=" +
      this.state.order.name;
    if (this.state.authenticate) {
      await _post(getDelivery).then((response) => {
        return response.json().then(async (data) => {
          if (data.result !== undefined) {
            await this.setState({
              delivery: data.result,
              alertUndefined: false,
            });
            await this.checkAvailability();
          } else {
            this.setState({ alertUndefined: true });
          }
        });
      });
    }
  };

  checkAvailability = async () => {
    const checkAvailability =
      constantURI() +
      "Action?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&action=" +
      "action_assign" +
      "&table=" +
      "stock.picking" +
      "&id=" +
      this.state.delivery[0].id;
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    if (this.state.authenticate) {
      await _post(checkAvailability);
      this.setQuantities();
    }
  };

  setQuantities = async () => {
    const transfer =
      constantURI() +
      "Action?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&action=" +
      "action_set_quantities_to_reservation" +
      "&table=" +
      "stock.picking" +
      "&id=" +
      this.state.delivery[0].id;
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    if (this.state.authenticate) {
      await _post(transfer);
      this.validate();
    }
  };

  validate = async () => {
    const validate =
      constantURI() +
      "Action?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&action=" +
      "button_validate" +
      "&table=" +
      "stock.picking" +
      "&id=" +
      this.state.delivery[0].id;
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    if (this.state.authenticate) {
      await _post(validate);
      const updateSignature =
        constantURI() +
        "updateDelivery?token=" +
        this.state.token +
        "&user=" +
        this.state.username +
        "&id=" +
        this.state.delivery[0].id;
      var body = {};
      body.signature = this.state.signature;
      await _postBody(updateSignature, body);
      await localStorage.setItem(
        "UnsyncedTransactionsCount",
        JSON.stringify([])
      );
      await localStorage.setItem("UnsyncedTransactions", JSON.stringify([]));
      await localStorage.setItem("PendingInvoices", JSON.stringify([]));

      await alert("Synced Successfully");
      await this.setState({ isDraft: true, isDelivered: false });
      await window.location.reload();
    }
  };

  onOrderClick = (item, usId) => {
    var temp = [
      {
        isDraft: this.state.isDraft,
        isDelivered: this.state.isDelivered,
        isDone: this.state.isDone,
      },
    ];
    localStorage.setItem("OrderId", JSON.stringify(item));
    if (usId !== undefined) {
      localStorage.setItem("USOrderId", JSON.stringify(usId));
    }
    localStorage.setItem("CurrentTab", JSON.stringify(temp));
    this.props.history.push("./SalesOrderDetail");
  };

  onClickCreate = async () => {
    //If current type is not payment
    if (this.state.currentType !== 3) {
      //If current type is delivery
      if (this.state.currentType === 4) {
        await this.checkedOrder();
        localStorage.setItem("IsDelivery", JSON.stringify(true));
        this.props.history.push("/Items");
      }
      //If current type is not delivery
      else {
        localStorage.setItem("IsDelivery", JSON.stringify(false));
        localStorage.setItem("CatalogType", JSON.stringify(2));
        this.props.history.push("./Catalogs");
      }
    }
    //If current type is payment
    else {
      localStorage.setItem("IsDelivery", JSON.stringify(false));
      var temp = [];
      await this.state.orders.map((order) => {
        if (order.checked !== undefined && order.checked) temp.push(order);
      });
      localStorage.setItem("PendingInvoices", JSON.stringify(temp));
      this.props.history.push("./Payment");
    }
  };

//   onChangeAmount = (order, index) => (e) => {
//     this.setState({
//       ...(this.state.orders[index].amountToPay = (e.target.value)),
//     });
//   };

// onChangeAmount = (order, index) => (e) => {
//   const value = e.target.value;

//   // Allow numbers + ONE decimal only
//   if (!/^\d*\.?\d*$/.test(value)) return;

//   this.setState(prevState => {
//     const orders = [...prevState.orders];

//     orders[index] = {
//       ...orders[index],
//       amountToPay: value
//     };

//     return { orders };
//   });
// };
onChangeAmount = (order, index) => (e) => {
  const value = e.target.value;

  // Allow empty string for editing
  if (value === "") {
    this.setState(prev => {
      const orders = [...prev.orders];
      orders[index] = { ...orders[index], amountToPay: "" };
      return { orders };
    });
    return;
  }

  // Allow numbers and decimals while typing
  // Prevent multiple dots
  if (!/^\d*\.?\d*$/.test(value)) return;

  this.setState(prev => {
    const orders = [...prev.orders];
    orders[index] = { ...orders[index], amountToPay: value };
    return { orders };
  });
};



  checkedOrder = async () => {
    var tempLines = [];
    var isTrue = false;
    await this.state.orders.map(async (order, orderIndex) => {
      if (order.checked !== undefined && order.checked === true) {
        isTrue = true;
        localStorage.setItem("CheckedOrder", JSON.stringify(order));
        await this.state.orderLine.map((line, lineIndex) => {
          if (order.id === line.order_id[0]) {
            tempLines.push(line);
          }
        });
        localStorage.setItem("CheckedOrderLine", JSON.stringify(tempLines));
      }
    });
    if (!isTrue) {
      localStorage.setItem("CheckedOrder", JSON.stringify([]));
      localStorage.setItem("CheckedOrderLine", JSON.stringify([]));
    }
  };

  // onChangeChecked = (index) => async (e) => {
  //   //If transaction type is payment
  //   if (this.state.currentType === 3) {
  //     await this.setState({
  //       ...(this.state.orders[index].checked = e.nativeEvent.target.checked),
  //     });
  //     if (this.state.orders[index].checked) {
  //       this.setState({
  //         ...(this.state.orders[index].amountToPay =
  //           this.state.orders[index].amount_residual),
  //       });
  //     } else {
  //       this.setState({ ...(this.state.orders[index].amountToPay = "") });
  //     }
  //     await this.isChecked();
  //   }
  //   //If transaction type is delivery
  //   else if (this.state.currentType === 4) {
  //     if (e.nativeEvent.target.checked) {
  //       await this.state.orders.map((order, orderIndex) => {
  //         if (order.checked !== undefined && order.checked === true) {
  //           this.setState({
  //             ...(this.state.orders[orderIndex].checked =
  //               !this.state.orders[orderIndex].checked),
  //           });
  //         }
  //       });
  //       await this.setState({
  //         ...(this.state.orders[index].checked =
  //           !this.state.orders[index].checked),
  //       });
  //     } else {
  //       await this.setState({
  //         ...(this.state.orders[index].checked = e.nativeEvent.target.checked),
  //       });
  //     }
  //   }
  // };

onChangeChecked = (index) => async (e) => {
  const checked = e.target.checked;
  let orders = [...this.state.orders];

  if (this.state.currentType === 3) {

    orders[index].checked = checked;

    if (checked) {
      orders[index].amountToPay = orders[index].amount_residual;

      orders.forEach((order, i) => {
        if (i !== index) {
          order.disabledByCheck = true;
        }
      });

    } else {
      orders[index].amountToPay = "";

      orders.forEach((order) => {
        order.disabledByCheck = false;
      });
    }

    await this.setState({ orders });
    await this.isChecked();
  }

  else if (this.state.currentType === 4) {

    if (checked) {
      orders.forEach((order, i) => {
        if (i === index) {
          order.checked = true;
        } else {
          order.disabledByCheck = true;
        }
      });
    } else {
      orders[index].checked = false;

      orders.forEach((order) => {
        order.disabledByCheck = false;
      });
    }

    await this.setState({ orders });
  }
};

  onChangeCheckedPending = (index) => async (e) => {
    //If transaction type is payment
    if (this.state.currentType === 3) {
      await this.setState({
        ...(this.state.pending[index].checked = e.nativeEvent.target.checked),
      });
      if (this.state.pending[index].checked) {
        this.setState({
          ...(this.state.pending[index].amountToPay =
            this.state.pending[index].amount_residual),
        });
      } else {
        this.setState({ ...(this.state.pending[index].amountToPay = "") });
      }
      await this.isChecked();
    }
    //If transaction type is delivery
    else if (this.state.currentType === 4) {
      if (e.nativeEvent.target.checked) {
        await this.state.orders.map((order, orderIndex) => {
          if (order.checked !== undefined && order.checked === true) {
            this.setState({
              ...(this.state.orders[orderIndex].checked =
                !this.state.orders[orderIndex].checked),
            });
          }
        });
        await this.setState({
          ...(this.state.orders[index].checked =
            !this.state.orders[index].checked),
        });
      } else {
        await this.setState({
          ...(this.state.orders[index].checked = e.nativeEvent.target.checked),
        });
      }
    }
  };

  header = () => {
    return (
      <div>
        {!this.state.alertUndefined ? null : (
          <div className="col alert alert-danger">
            <div className="row">
              <h6 className="col-sm-8">There seems to be a problem.</h6>
              <div className="col d-flex flex-row-reverse">
                <div
                  className="btn"
                  style={stylesMed.wideButton}
                  onClick={() => window.location.reload()}
                >
                  Reload
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="pt-3 row">
          <div className="col">
            <ArrowBackCircle
              className="btn col"
              onClick={() => this.props.history.push("./TransactionsPage")}
              color={"#65a0ff"}
              height="50px"
              width="50px"
            />
          </div>
          <div
            className="col d-flex flex-row-reverse"
            style={
              this.state.currentType === 3 && !this.state.isChecked
                ? stylesASAP.disable
                : null
            }
          >
            <div
              className="col-sm-4 btn"
              onClick={() => this.onClickCreate()}
              style={stylesASAP.soButton}
            >
              <b>
                Create{" "}
                {this.state.currentType !== -1
                  ? this.state.transactionTypes[this.state.currentType].button
                  : null}{" "}
                <FcPlus size={35} />
              </b>
            </div>
          </div>
        </div>
        {/* <div className="pt-3">
                    <input type="text" className="form-control" placeholder="Search Here"
                           onChange={(text) => this.onSearch(text)}/>
                </div> */}
        <p className="pt-3 text-center h3">
          {this.state.currentType !== -1
            ? this.state.transactionTypes[this.state.currentType].name
            : null}{" "}
          List
        </p>

        <div className="row mt-3">
          {/* <div className="col btn h4 text-center"
                         style={(this.state.isDraft && !this.state.isDelivered && !this.state.isDone) ? stylesASAP.pressedTab : stylesASAP.unpressedTab}
                         onClick={() => this.onTabPress(true, false, false)}>Draft
                    </div> */}
          <div
            className="col btn h4 text-center"
            style={
              this.state.isDraft && !this.state.isDone
                ? stylesASAP.pressedTab
                : stylesASAP.unpressedTab
            }
            onClick={() => this.onTabPress(true, true, false)}
          >
            Unsynced
          </div>
          <div
            className="col btn h4 text-center"
            style={
              !this.state.isDraft && !this.state.isDone
                ? stylesASAP.pressedTab
                : stylesASAP.unpressedTab
            }
            onClick={() => this.onTabPress(false, true, false)}
          >
            {this.state.currentType !== 3 ? "Sent" : "Posted"}
          </div>
          {/* {(this.state.currentType !== 3) ? <div className="col btn h4 text-center"
                                                           style={(!this.state.isDraft && !this.state.isDelivered && !this.state.isDone) ? stylesASAP.pressedTab : stylesASAP.unpressedTab}
                                                           onClick={() => this.onTabPress(false, false, false)}>{(this.state.currentType === 2) ? "ToApprove" : "Sale"}</div> : null
                    }
                    {(this.state.currentType === 2) ? <div className="col btn h4 text-center"
                                                           style={(!this.state.isDraft && !this.state.isDelivered && this.state.isDone) ? stylesASAP.pressedTab : stylesASAP.unpressedTab}
                                                           onClick={() => this.onTabPress(false, false, true)}>Purchase</div>
                        : null
                    } */}
          {/* <div className="col btn h4 text-center"
                         style={(this.state.isDraft && this.state.isDelivered && this.state.isDone) ? stylesASAP.pressedTab : stylesASAP.unpressedTab}
                         onClick={() => this.onTabPress(true, true, true)}>Done
                    </div>
                    <div className="col btn h4 text-center"
                         style={(this.state.isDraft && !this.state.isDelivered && this.state.isDone) ? stylesASAP.pressedTab : stylesASAP.unpressedTab}
                         onClick={() => this.onTabPress(true, false, true)}>Canceled
                    </div> */}
        </div>

        {/*<div className="col d-flex flex-row-reverse">*/}
        {/*    {*/}
        {/*        (this.state.isDelivered && this.state.isDraft && !this.state.isDone) ?*/}
        {/*            <div className={(!this.state.disbaleSync) ? "btn" : "btn disabled"} style={stylesASAP.syncButton} onClick={this.onSync}>Sync Data</div>*/}
        {/*            : null*/}
        {/*    }*/}
        {/*</div>*/}
      </div>
    );
  };

  // orderCard = (order, index, isPending) => {
  //     var data = [];
  //     if (this.state.currentType !== 3) {
  //         data = [{"name": "Total", data: order.amount_total}, {"name": "Date", data: order.date_order},
  //             {"name": "Client", data: order.partner_id[1]}, {"name": "Status", data: order.state}];
  //     } else {
  //         data = [{"name": "Total", data: order.amount_total}, {"name": "Date", data: order.invoice_date},
  //             {"name": "Remaining", data: order.amount_residual}, {"name": "To Pay", data: ""}];
  //     }
  //     return (
  //         <div className="row pb-2" style={stylesASAP.mainBackgroundColor} key={index}>
  //             <div className="col-sm-3" style={stylesASAP.cardfirsthalf}>
  //                 {(this.state.currentType === 3 || this.state.currentType === 4) ?
  //                     (isPending) ?
  //                         <input type="checkbox" className="form-check-input" style={stylesASAP.checkbox}
  //                                defaultChecked={this.state.pending[index].checked}
  //                                checked={this.state.pending[index].checked} value={this.state.pending[index].checked}
  //                                onChange={this.onChangeCheckedPending(index)}/>
  //                         :
  //                         <input type="checkbox" className="form-check-input" style={stylesASAP.checkbox}
  //                                defaultChecked={this.state.orders[index].checked}
  //                                checked={this.state.orders[index].checked} value={this.state.orders[index].checked}
  //                                onChange={this.onChangeChecked(index)}
  //                                disabled={(this.state.orders[index].disable !== true) ? false : true}/>
  //                     : null
  //                 }
  //                 <div className="text-center h5">
  //                     {(!isPending) ?
  //                         (this.state.orders[index].disable !== true) ?
  //                             null
  //                             :
  //                             <p style={{color: "red"}}>UNSYNCED</p>
  //                         : null
  //                     }
  //                     <p style={{color: "#00bfff"}}>{order.name}</p>
  //                 </div>
  //             </div>
  //             <div className="col-sm-9" style={stylesASAP.cardsecondhalf}
  //                  onClick={(this.state.currentType !== 3) ? () => this.onOrderClick(order.id, order.usId) : null}>
  //                 <div className="row">
  //                     {data.map((item, index2) => {
  //                         return (
  //                             <div className="col" key={index2}>
  //                                 <div className="row">
  //                                     <div className="col-sm-6">
  //                                         <p className="card-text" style={stylesASAP.fadedText}>{item.name}</p>
  //                                     </div>
  //                                     {(item.name !== "To Pay") ?
  //                                         <div className="col-sm-6">
  //                                             <p className="card-text" style={stylesASAP.overflow}>{item.data}</p>
  //                                         </div> :
  //                                         <div
  //                                             style={(order.checked) ? stylesASAP.amountToPay : stylesASAP.amountToPayDisable}>
  //                                             <input className="col form-control"
  //                                                    value={(this.state.orders[index] !== undefined) ? this.state.orders[index].amountToPay : null}
  //                                                    onChange={this.onChangeAmount(order, index)}
  //                                                    onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()}
  //                                                    min="1"
  //                                             />
  //                                         </div>
  //                                     }
  //                                 </div>
  //                             </div>
  //                         )
  //                     })
  //                     }
  //                 </div>
  //             </div>
  //         </div>
  //     )
  // }

  // orderCard = (order, index, isPending) => {
  //     var data = [];
  //     if (this.state.currentType !== 3) {
  //         data = [{"name": "Total", data: order.amount_total}, {"name": "Date", data: order.date_order},
  //             {"name": "Client", data: order.partner_id[1]}, {"name": "Status", data: order.state}];
  //     } else {
  //         data = [{"name": "Total", data: order.amount_total}, {"name": "Date", data: order.invoice_date},
  //             {"name": "Remaining", data: order.amount_residual}, {"name": "To Pay", data: ""}];
  //     }
  //     return (
  //         <div className="row pb-2" style={{ backgroundColor: "#f0f0f0", padding: "15px", marginBottom: "10px" }} key={index}>
  //             <div className="col-sm-3" style={{ backgroundColor: "#eaeaea", padding: "10px", borderRadius: "5px" }}>
  //                 {(this.state.currentType === 3 || this.state.currentType === 4) ?
  //                     (isPending) ?
  //                         <input type="checkbox" className="form-check-input" style={{ margin: "5px" }}
  //                             defaultChecked={this.state.pending[index].checked}
  //                             checked={this.state.pending[index].checked} value={this.state.pending[index].checked}
  //                             onChange={this.onChangeCheckedPending(index)} />
  //                         :
  //                         <input type="checkbox" className="form-check-input" style={{ margin: "5px" }}
  //                             defaultChecked={this.state.orders[index].checked}
  //                             checked={this.state.orders[index].checked} value={this.state.orders[index].checked}
  //                             onChange={this.onChangeChecked(index)}
  //                             disabled={(this.state.orders[index].disable !== true) ? false : true} />
  //                     : null
  //                 }
  //                 <div className="text-center h5">
  //                     {(!isPending) ?
  //                         (this.state.orders[index].disable !== true) ?
  //                             null
  //                             :
  //                             <p style={{ color: "red" }}>UNSYNCED</p>
  //                         : null
  //                     }
  //                     <p style={{ color: "#008080" }}>{order.name}</p>
  //                 </div>
  //             </div>
  //             <div className="col-sm-9" style={{ backgroundColor: "#ffffff", padding: "10px", borderRadius: "5px" }}
  //                 onClick={(this.state.currentType !== 3) ? () => this.onOrderClick(order.id, order.usId) : null}>
  //                 <div className="row">
  //                     {data.map((item, index2) => {
  //                         return (
  //                             <div className="col" key={index2}>
  //                                 <div className="row">
  //                                     <div className="col-sm-6">
  //                                         <p className="card-text" style={{ color: "#555", fontWeight: "bold" }}>{item.name}</p>
  //                                     </div>
  //                                     {(item.name !== "To Pay") ?
  //                                         <div className="col-sm-6">
  //                                             <p className="card-text" style={{ color: "#333" }}>{item.data}</p>
  //                                         </div> :
  //                                         <div
  //                                             style={(order.checked) ? { color: "#008080", fontWeight: "bold" } : { color: "#777", fontWeight: "bold" }}>
  //                                             <input className="col form-control"
  //                                                 value={(this.state.orders[index] !== undefined) ? this.state.orders[index].amountToPay : null}
  //                                                 onChange={this.onChangeAmount(order, index)}
  //                                                 onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()}
  //                                                 min="1"
  //                                             />
  //                                         </div>
  //                                     }
  //                                 </div>
  //                             </div>
  //                         )
  //                     })}
  //                 </div>
  //             </div>
  //         </div>
  //     )
  // }

  // orderCard = (order, index, isPending) => {
  //     var data = [];
  //     if (this.state.currentType !== 3) {
  //         data = [
  //             { "name": "Total", data: order.amount_total },
  //             { "name": "Date", data: order.date_order },
  //             { "name": "Client", data: order.partner_id[1] },
  //             { "name": "Status", data: order.state }
  //         ];
  //     } else {
  //         data = [
  //             { "name": "Total", data: order.amount_total },
  //             { "name": "Date", data: order.invoice_date },
  //             { "name": "Remaining", data: order.amount_residual },
  //             { "name": "To Pay", data: "" }
  //         ];
  //     }

  //     return (
  //         <div className="card" style={{ backgroundColor: "#f0f0f0", marginBottom: "10px" }} key={index}>
  //             <div className="card-header" style={{ backgroundColor: "#eaeaea", borderBottom: "1px solid #ccc" }}>
  //                 <div className="row">
  //                     <div className="col-sm-3">
  //                         {(this.state.currentType === 3 || this.state.currentType === 4) ?
  //                             (isPending) ?
  //                                 <input type="checkbox" className="form-check-input" style={{ margin: "5px" }}
  //                                     defaultChecked={this.state.pending[index].checked}
  //                                     checked={this.state.pending[index].checked}
  //                                     value={this.state.pending[index].checked}
  //                                     onChange={this.onChangeCheckedPending(index)} />
  //                                 :
  //                                 <input type="checkbox" className="form-check-input" style={{ margin: "5px" }}
  //                                     defaultChecked={this.state.orders[index].checked}
  //                                     checked={this.state.orders[index].checked}
  //                                     value={this.state.orders[index].checked}
  //                                     onChange={this.onChangeChecked(index)}
  //                                     disabled={(this.state.orders[index].disable !== true) ? false : true} />
  //                             : null
  //                         }
  //                     </div>
  //                     <div className="col-sm-9 text-center">
  //                         {(!isPending) ?
  //                             (this.state.orders[index].disable !== true) ?
  //                                 null
  //                                 :
  //                                 <p style={{ color: "red" }}>UNSYNCED</p>
  //                             : null
  //                         }
  //                         <h5 style={{ color: "#008080" }}>{order.name}</h5>
  //                     </div>
  //                 </div>
  //             </div>
  //             <div className="card-body" style={{ backgroundColor: "#ffffff" }}
  //                 onClick={(this.state.currentType !== 3) ? () => this.onOrderClick(order.id, order.usId) : null}>
  //                 <div className="row">
  //                     {data.map((item, index2) => (
  //                         <div className="col" key={index2}>
  //                             <div className="row">
  //                                 <div className="col-sm-6">
  //                                     <p className="card-text" style={{ color: "#555", fontWeight: "bold" }}>{item.name}</p>
  //                                 </div>
  //                                 <div className="col-sm-6">
  //                                     {(item.name !== "To Pay") ?
  //                                         <p className="card-text" style={{ color: "#333" }}>{item.data}</p>
  //                                         :
  //                                         <div style={(order.checked) ? { color: "#008080", fontWeight: "bold" } : { color: "#777", fontWeight: "bold" }}>
  //                                             <input className="col form-control"
  //                                                 value={(this.state.orders[index] !== undefined) ? this.state.orders[index].amountToPay : null}
  //                                                 onChange={this.onChangeAmount(order, index)}
  //                                                 onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()}
  //                                                 min="1"
  //                                             />
  //                                         </div>
  //                                     }
  //                                 </div>
  //                             </div>
  //                         </div>
  //                     ))}
  //                 </div>
  //             </div>
  //         </div>
  //     )
  // }

  orderCard = (order, index, isPending) => {
    var data = [];
    if (this.state.currentType !== 3) {
      data = [
        { name: "Total", data: order.amount_total },
        { name: "Date", data: order.date_order },
        { name: "Client", data: order.partner_id[1] },
        { name: "Status", data: order.state },
      ];
    } else {
      data = [
        { name: "Total", data: order.amount_total },
        { name: "Date", data: order.invoice_date },
        { name: "Remaining", data: order.amount_residual },
        { name: "To Pay", data: "" },
      ];
    }

    return (
      <div
        className="card"
        style={{ backgroundColor: "#f0f0f0", marginBottom: "10px" }}
        key={index}
      >
        <div
          className="card-header"
          style={{ backgroundColor: "#eaeaea", borderBottom: "1px solid #ccc" }}
        >
          <div className="row">
            <div className="col-sm-5">
              {this.state.currentType === 3 || this.state.currentType === 4 ? (
                isPending ? (
                  <input
                    type="checkbox"
                    className="form-check-input"
                    style={{ margin: "5px", width: "30px", height: "30px" }}
                    // defaultChecked={this.state.pending[index].checked}
                    checked={this.state.pending[index].checked}
                    value={this.state.pending[index].checked}
                    onChange={this.onChangeCheckedPending(index)}
                  />
                ) : (
                  <input
                    type="checkbox"
                    className="form-check-input"
                    style={{ margin: "5px", width: "30px", height: "30px" }}
                    // defaultChecked={this.state.orders[index].checked}
                    checked={this.state.orders[index].checked}
                    value={this.state.orders[index].checked}
                    onChange={this.onChangeChecked(index)}
                    // disabled={
                    //   this.state.orders[index].disable !== true ? false : true
                    // }
                    disabled={
    this.state.orders[index].disable ||
    this.state.orders[index].disabledByCheck
  }
                    
                  />
                )
              ) : null}
            </div>
            <div className="col-sm-7 ">
              {!isPending ? (
                this.state.orders[index].disable !== true ? null : (
                  <p style={{ color: "red" }}>UNSYNCED</p>
                )
              ) : null}
              <h5 style={{ color: "#008080" }}>{order.name}</h5>
            </div>
          </div>
        </div>
        <div
          className="card-body"
          style={{ backgroundColor: "#ffffff" }}
          onClick={
            this.state.currentType !== 3
              ? () => this.onOrderClick(order.id, order.usId)
              : null
          }
        >
          <div className="row">
            {data.map((item, index2) => (
              <div className="col-md-12" key={index2}>
                <div className="row">
                  <div className="col-sm-4 mt-1 ">
                    <p
                      className="card-text "
                      style={{ color: "#555", fontWeight: "bold" }}
                    >
                      {item.name}
                    </p>
                  </div>
                  <div className="col-sm-8">
                    {item.name !== "To Pay" ? (
                      <p className="card-text" style={{ color: "#333" }}>
                        {item.data}
                      </p>
                    ) : (
                      <div
                        style={
                          order.checked
                            ? { color: "#008080", fontWeight: "bold" }
                            : { color: "#777", fontWeight: "bold" }
                        }
                      >
                        <input
                          className="col form-control"
                          value={
                            this.state.orders[index] !== undefined
                              ? this.state.orders[index].amountToPay
                              : null
                          }
                          onChange={this.onChangeAmount(order, index)}
                        //   step="0.1"
                        //   onKeyDown={(e) =>
                        //     this.state.preventSymbols.includes(e.key) &&
                        //     e.key !== "." && // ✅ allow decimal point
                        //     e.preventDefault()
                        //   }
                          onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()}
                          min="1"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  render() {
    console.log(this.state.currentType);
    if (this.state.loading) {
      return (
        <div
          className="container-fluid vh-100"
          style={stylesASAP.mainContainer}
        >
          {this.header()}
          <div className="pt-3 text-center">
            <div className="spinner-border" style={stylesASAP.spinner}></div>
          </div>
        </div>
      );
    } else {
      return (
        <div
          className="container-fluid vh-100"
          style={stylesASAP.mainContainer}
        >
          {this.header()}

          <div className="row">
            {this.state.orders.map((item, index) => {
              if (
                ((item.state === "sent" || item.state === "posted") &&
                  this.state.isDelivered &&
                  !this.state.isDraft &&
                  !this.state.isDone) ||
                (item.state === "sale" &&
                  !this.state.isDelivered &&
                  !this.state.isDraft &&
                  !this.state.isDone) ||
                (item.state === "draft" &&
                  !this.state.isDelivered &&
                  this.state.isDraft &&
                  !this.state.isDone) ||
                (item.state === "done" &&
                  this.state.isDelivered &&
                  this.state.isDraft &&
                  this.state.isDone) ||
                (item.state === "to approve" &&
                  this.state.isDelivered &&
                  this.state.isDraft &&
                  this.state.isDone) ||
                (item.state === "purchase" &&
                  !this.state.isDelivered &&
                  !this.state.isDraft &&
                  this.state.isDone) ||
                (item.state === "cancel" &&
                  !this.state.isDelivered &&
                  this.state.isDraft &&
                  this.state.isDone)
              ) {
                return (
                  <div key={index} className="col-md-4 mb-3">
                    {this.orderCard(item, index, false)}
                  </div>
                );
              } else {
                return null;
              }
            })}
          </div>

          <div className="row">
            {this.state.pending.map((item, index) => {
              if (
                this.state.isDelivered &&
                this.state.isDraft &&
                !this.state.isDone &&
                item !== null
              ) {
                return (
                  <div key={index} className="col-md-4 mb-3">
                    {this.orderCard(item, index, true)}
                  </div>
                );
              } else {
                return null;
              }
            })}
          </div>
        </div>
      );
    }
  }
}
